import React, { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'

const CHANNEL_NAME = 'slack_oauth'

const SlackCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const slack = searchParams.get('slack')
    const reason = searchParams.get('reason') ?? undefined
    const result = slack === 'connected' ? 'connected' : 'error'

    // BroadcastChannel is the reliable path — works even when window.opener is
    // nulled out by the browser after cross-origin redirect chains.
    try {
      const channel = new BroadcastChannel(CHANNEL_NAME)
      channel.postMessage({ type: 'slack_oauth', result, reason })
      channel.close()
    } catch {
      // BroadcastChannel not supported — fall back to postMessage
    }

    // Also try postMessage in case the parent is listening for it
    try {
      if (window.opener) {
        window.opener.postMessage(
          { type: 'slack_oauth', result, reason },
          window.location.origin,
        )
      }
    } catch {
      // opener may be restricted
    }

    // Always close the popup. If window.close() is blocked, redirect to settings.
    try {
      window.close()
    } catch {
      // some browsers block window.close() — fall through to navigate
    }

    // Short delay to let window.close() take effect before navigating
    const t = setTimeout(() => {
      if (!window.closed) {
        navigate('/dashboard/settings', { replace: true })
      }
    }, 300)

    return () => clearTimeout(t)
  }, [searchParams, navigate])

  return (
    <div className="flex h-screen items-center justify-center">
      <p className="text-sm text-gray-500">Completing Slack connection…</p>
    </div>
  )
}

export default SlackCallbackPage
